export default __webpack_public_path__ + "static/media/secure.b95d23af.svg";